import { oc } from "@orpc/contract";
import { z } from "zod";

export const UiBugReportContextSchema = z.object({
  userId: z.string(),
  userName: z.string(),
  userEmail: z.string().nullable(),
  organizationId: z.string(),
  organizationName: z.string(),
  pageUrl: z.string(),
  pageTitle: z.string(),
  userAgent: z.string(),
  screenWidth: z.number(),
  screenHeight: z.number(),
  viewportWidth: z.number(),
  viewportHeight: z.number(),
  timestamp: z.string(),
});

export const uiBugReportContracts = {
  /**
   * Submit a UI bug report / feedback from the user.
   * Captures user context, current page info, optional screenshot, and free-text message.
   */
  submit: oc
    .input(
      z.object({
        message: z.string().min(1).max(5000),
        screenshotDataUrl: z.string().nullable().optional(),
        context: UiBugReportContextSchema,
      }),
    )
    .output(z.object({ success: z.boolean() }))
    .route({ method: "POST" }),
} as const;

export type UiBugReportContext = z.infer<typeof UiBugReportContextSchema>;
